var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 2H12.25C13.0784 2 13.75 2.67157 13.75 3.5V13.25C13.75 14.0784 13.0784 14.75 12.25 14.75H1.75C0.921573 14.75 0.25 14.0784 0.25 13.25V3.5C0.25 2.67157 0.921573 2 1.75 2H2.5V0.875C2.5 0.667893 2.66789 0.5 2.875 0.5H3.625C3.83211 0.5 4 0.667893 4 0.875V2H10V0.875C10 0.667893 10.1679 0.5 10.375 0.5H11.125C11.3321 0.5 11.5 0.667893 11.5 0.875V2ZM1.75 13.25H12.25V5H1.75V13.25Z",
    fill: "#111D43"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalender);
export default __webpack_public_path__ + "static/media/ic-calender.90aa8a5cf75c5406e2a23c5d8faff802.svg";
export { ForwardRef as ReactComponent };